import { motion } from "framer-motion";
import { fadeUp, revealOnce, stagger } from "../../motion";
import "../../css/ProfPort.css";

const ProfPort = () => {
  return (
    <section className="section profport">
      <motion.div
        className="profport__panel container"
        variants={stagger}
        {...revealOnce}
      >
        <motion.span className="eyebrow" variants={fadeUp}>
          Professional portfolio
        </motion.span>
        <motion.h2 className="profport__title" variants={fadeUp}>
          Transforming ideas into <span className="text-gradient">reality</span>
        </motion.h2>
        <motion.p className="profport__text" variants={fadeUp}>
          I&apos;ve been building software and engineering systems since 2021,
          with a focus on cutting-edge technologies and seamless user
          experiences. My portfolio spans a diverse range of projects across both
          development and IT infrastructure. Let&apos;s collaborate and bring your
          ideas to life.
        </motion.p>
        <motion.a
          className="btn btn-primary"
          variants={fadeUp}
          href="https://www.linkedin.com/in/akinolaoshinubi/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Connect on LinkedIn
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
          </svg>
        </motion.a>
      </motion.div>
    </section>
  );
};

export default ProfPort;
